import { isUndefined } from 'lodash-es'
import {
    SET_BREADCRUMB_MAPPING,
    SET_IGNORE_WORDS,
} from 'store/actions/breadCrumb.action'
import { IAction } from 'types/storeTypes'

interface IState {
    guidMapping: Map<string, string>
    loading: boolean
    ignorePaths: string[]
}

const initState: IState = {
    guidMapping: new Map<string, string>(),
    loading: false,
    ignorePaths: [],
}

const breadCrumbReducer = (
    state: IState = initState,
    action: IAction,
): IState => {
    const { type, payload } = action
    switch (type) {
        case SET_BREADCRUMB_MAPPING: {
            if (isUndefined(payload.value)) {
                return state
            }
            const newMap = state.guidMapping.set(payload.key, payload.value)
            return {
                ...state,
                guidMapping: new Map(newMap),
            }
        }
        case SET_IGNORE_WORDS: {
            return {
                ...state,
                ignorePaths: payload,
            }
        }
        default:
            return state
    }
}

export default breadCrumbReducer
